module.exports = __webpack_public_path__ + "img/beginning.c46622e.webp";